import { withNamespaces } from 'react-i18next';

import { VerificationStates } from '../constants';

const VerificationStatus = ({
    t,
    verification,
}) => {
    const total = VerificationStates.reduce((sum, state) => sum + (verification[state.key] || 0), 0) || 1;

    return (
        <div className="verification-status">
            <div className="verification-bar">
                {VerificationStates.map((state) => {
                    const value = verification[state.key] || 0;

                    if (!value) return null;

                    return (
                        <span
                            className={`verification-bar-segment ${state.className}`}
                            key={state.key}
                            style={{ width: `${(value / total) * 100}%` }}
                            title={`${value} ${t(state.title)}`}
                        />
                    );
                })}
            </div>

            <div className="verification-caption">
                {VerificationStates.map((state, index) => (
                    <span className={state.className} key={state.key}>
                        {`${verification[state.key] || 0} ${t(state.title)}`}
                        {index < VerificationStates.length - 1 ? ' · ' : ''}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default withNamespaces()(
    VerificationStatus
);
